import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { useContent } from '../../services'

/* ── phone auto-format helper ── */
const formatPhoneNumber = (value) => {
    const digits = value.replace(/\D/g, '').slice(0, 10);
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

/* ── Generate 30-min time slots from 11 AM to 2 AM ── */
const generateTimeSlots = () => {
    const slots = [];
    for (let h = 11; h <= 23; h++) {
        for (let m = 0; m < 60; m += 30) {
            const hour12 = h > 12 ? h - 12 : h;
            const ampm = h >= 12 ? 'PM' : 'AM';
            slots.push(`${hour12}:${m === 0 ? '00' : '30'} ${ampm}`);
        }
    }
    for (let h = 0; h <= 2; h++) {
        const limit = h === 2 ? 1 : 2;
        for (let m = 0; m < limit * 30; m += 30) {
            const hour12 = h === 0 ? 12 : h;
            slots.push(`${hour12}:${m === 0 ? '00' : '30'} AM`);
        }
    }
    return slots;
};
const TIME_SLOTS = generateTimeSlots();

function ReservationForm() {
    const [selectedDate, setSelectedDate] = useState(null);
    const [phone, setPhone] = useState('');
    const [persons, setPersons] = useState(2);
    const [selectedTime, setSelectedTime] = useState(null);
    const [showTimeGrid, setShowTimeGrid] = useState(false);

    const { data: reservation, loading: loadingR } = useContent('homeReservation');
    const { data: businessInfo, loading: loadingB } = useContent('businessInfo');

    if (loadingR || loadingB || !reservation || !businessInfo) return null;

    return (
        <section className="reserve-section reserve-redesigned">
            <div className="auto-container">
                <div className="outer-box">
                    <div className="row clearfix">
                        <div className="reserv-col col-lg-8 col-md-12 col-sm-12">
                            <div className="inner">
                                <div className="title">
                                    <h2>{reservation.title}</h2>
                                    <div className="request-info">
                                        {reservation.bookingText}{' '}
                                        <Link to={businessInfo.phoneLink}>{reservation.bookingPhone}</Link>{' '}
                                    </div>
                                </div>

                                <form className="rsv-form" method="post" action="/">
                                    <div className="rsv-row rsv-row--2">
                                        <div className="rsv-field">
                                            <label className="rsv-label">Your Name</label>
                                            <input type="text" name="name" placeholder="John Doe" required />
                                        </div>
                                        <div className="rsv-field">
                                            <label className="rsv-label">Phone Number</label>
                                            <input
                                                type="tel"
                                                name="phone"
                                                placeholder="(555) 123-4567"
                                                value={phone}
                                                onChange={(e) => setPhone(formatPhoneNumber(e.target.value))}
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="rsv-row rsv-row--3">
                                        <div className="rsv-field">
                                            <label className="rsv-label">Guests</label>
                                            <div className="rsv-stepper">
                                                <button type="button" onClick={() => setPersons(Math.max(1, persons - 1))}>
                                                    <span className="fas fa-minus"></span>
                                                </button>
                                                <span className="rsv-stepper__val">{persons}</span>
                                                <button type="button" onClick={() => setPersons(Math.min(20, persons + 1))}>
                                                    <span className="fas fa-plus"></span>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="rsv-field">
                                            <label className="rsv-label">Date</label>
                                            <div className="rsv-date-wrap">
                                                <span className="rsv-icon far fa-calendar"></span>
                                                <DatePicker
                                                    selected={selectedDate}
                                                    onChange={(date) => setSelectedDate(date)}
                                                    placeholderText="MM/DD/YYYY"
                                                    dateFormat="MM/dd/yyyy"
                                                    minDate={new Date()}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="rsv-field">
                                            <label className="rsv-label">Time</label>
                                            <div className="rsv-time-wrap">
                                                <span className="rsv-icon far fa-clock"></span>
                                                <div className="rsv-time-display" onClick={() => setShowTimeGrid(!showTimeGrid)}>
                                                    {selectedTime || 'Select Time'}
                                                </div>
                                                <span className="rsv-chevron far fa-angle-down" onClick={() => setShowTimeGrid(!showTimeGrid)}></span>
                                                {showTimeGrid && (
                                                    <div className="rsv-time-dropdown">
                                                        <div className="rsv-time-dropdown__head">
                                                            <span>Pick a Time</span>
                                                            <button type="button" onClick={() => setShowTimeGrid(false)}>&times;</button>
                                                        </div>
                                                        <div className="rsv-time-grid">
                                                            {TIME_SLOTS.map((slot) => (
                                                                <button
                                                                    key={slot}
                                                                    type="button"
                                                                    className={selectedTime === slot ? 'active' : ''}
                                                                    onClick={() => { setSelectedTime(slot); setShowTimeGrid(false); }}
                                                                >
                                                                    {slot}
                                                                </button>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="rsv-row rsv-row--1">
                                        <div className="rsv-field rsv-field--full">
                                            <label className="rsv-label">Special Requests</label>
                                            <textarea name="message" placeholder="Any dietary needs, seating preferences, or celebration details..." rows="4"></textarea>
                                        </div>
                                    </div>

                                    <div className="rsv-row rsv-row--1">
                                        <div className="rsv-field rsv-field--full">
                                            <button type="submit" className="rsv-submit">
                                                <span className="far fa-calendar-check"></span> Book a Table
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                        <div className="info-col col-lg-4 col-md-12 col-sm-12">
                            <div className="inner">
                                <div className="title">
                                    <h2>Contact Us</h2>
                                </div>
                                <div className="rsv-info-cards">
                                    <div className="rsv-info-card">
                                        <span className="rsv-info-icon fas fa-phone-alt"></span>
                                        <div className="rsv-info-card__label">Booking Request</div>
                                        <Link to={businessInfo.phoneLink} className="rsv-info-card__value rsv-info-card__value--phone">{businessInfo.phone}</Link>
                                    </div>
                                    <div className="rsv-info-card">
                                        <span className="rsv-info-icon fas fa-map-marker-alt"></span>
                                        <div className="rsv-info-card__label">Location</div>
                                        <div className="rsv-info-card__value">{businessInfo.address}</div>
                                    </div>
                                    <div className="rsv-info-card">
                                        <span className="rsv-info-icon far fa-clock"></span>
                                        <div className="rsv-info-card__label">Open Hours</div>
                                        <div className="rsv-info-card__value">
                                            Sun – Thu: {businessInfo.openTime} – {businessInfo.closeTimeSunThu}<br />
                                            Fri – Sat: {businessInfo.openTime} – {businessInfo.closeTimeFriSat}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ReservationForm
